export default __webpack_public_path__ + "static/media/debate_27.a29cd0fa.JPG";